import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutEdiTemplateLookup extends Layout {
}
